export default {
  // momentjs constants
  M_FMT_MS: 'x',
  M_FMT_READABLE_WEEKDAY: 'ddd MMM D, YYYY'
}



// WEBPACK FOOTER //
// ./src/constants.js